<template>
    <nav class="navbar navbar-expand-lg navbar-fixed">
        <div class="container-fluid">
            <div class="navbar-wrapper">
                <div class="navbar-minimize" @click="sideBarToggleMini">
                    <button id="minimizeSidebar" class="all-btn edit-btn btn-round d-none d-lg-flex" style="width: 38px; height: 38px">
                        <i class="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
                        <i class="fa fa-navicon visible-on-sidebar-mini"></i>
                    </button>
                </div>
                <div class="navbar-brand">{{$t(navbar.title)}}</div>
            </div>
            <button class="navbar-toggler" type="button" :class="{'toggled': sidebar.mobile}"
                    data-toggle="collapse" aria-controls="navigation-index"
                    aria-expanded="true" aria-label="Toggle navigation"
                    @click="sideBarToggleMobile">
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
            </button>

          <div class="collapse navbar-collapse justify-content-end">
            <div class="col-12">
              <select style="border: none;color:lightslategray">
                <option :value="option.key" v-for="option in currencyRates" :key="option.id">
                  <template>{{ option.value }} сўм</template>
                </option>
              </select>
            </div>
          </div>

            <div class="collapse navbar-collapse justify-content-end">
                <ul class="navbar-nav">
                    <li class="nav-item dropdown nav-dropdown-language" :class="{'show': langNavShow}">
                        <a class="nav-link dropdown-toggle" href="#" @click="langNavToggle" v-click-outside="langNavHide">
                            {{language}}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="#" class="dropdown-item" :class="{'active': languageCode === 'uz'}" @click="changeLanguage('uz')">
                                Ўзбек тили
                            </a>
                            <a href="#" class="dropdown-item" :class="{'active': languageCode === 'ru'}" @click="changeLanguage('ru')">
                                Русский язык
                            </a>
                        </div>
                    </li>
                    <li class="nav-item dropdown" :class="{'show': userNavShow}">
                        <a class="nav-link dropdown-toggle" href="#" @click="userNavToggle" v-click-outside="userNavHide">
                            {{profile.firstname}} {{profile.lastname}}
                          <div class="user-auth-method-wrapper">
                            <span v-if="isLoggedInViaKeycloak" class="user-auth-method keycloak-auth-method">
                              <img src="../../assets/images/keycloak-logo.svg" alt="keycloak-logo.svg" class="auth-method-logo"/>
                              <span class="auth-method-name">KEYCLOAK</span>
                            </span>
                            <span v-else class="user-auth-method legacy-auth-method">
                              <span class="auth-method-name">LEGACY</span>
                            </span>
                          </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <router-link tag="a" to="/my-profile" class="dropdown-item" >
                            Profile
                          </router-link>
                            <router-link tag="a" to="/config/cadastre" class="dropdown-item" v-if="hasPermission('SETTINGS_REAL_ESTATE')">
                                {{$t("config.title")}}
                            </router-link>
                            <router-link  tag="a" to="/config/auto" class="dropdown-item" v-if="hasPermission('SETTINGS_AUTO')">
                                {{$t("config.autoConfig")}}
                            </router-link>
                            <router-link v-if="hasPermission('PERMISSIONS')" tag="a" to="/config/permission" class="dropdown-item">
                                {{$t("config.permission")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_RE_EVALUATE')" tag="a" to="/config/re-evaluate" class="dropdown-item">
                                {{$t("config.reEvaluate.title")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_CONTRACT_REGION')" tag="a" to="/config/contractRegion" class="dropdown-item">
                                {{$t('config.contractRegion')}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_CONTRACT_AMOUNT')" tag="a" to="/config/contractAmount" class="dropdown-item">
                                {{$t('config.contractAmount')}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_CURRENCY_RATE')" tag="a" to="/config/currency-rate" class="dropdown-item">
                                {{$t("config.currency")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_POPULATION_INCOME')" tag="a" to="/config/population-income" class="dropdown-item">
                                {{$t("config.populationIncome.title")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_PRODUCT')" tag="a" to="/config/product" class="dropdown-item">
                                {{$t("config.product.title")}}
                            </router-link>
                            <router-link  tag="a" to="/config/products" class="dropdown-item">
                                {{$t("config.products.title")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_RENTAL_RATES')" tag="a" to="/config/rental-rates" class="dropdown-item">
                                {{$t("config.rentalRates")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_TENDER')" tag="a" to="/config/tender" class="dropdown-item">
                                {{$t("config.tender")}}
                            </router-link>
                            <router-link tag="a" to="/config/companies-tariff" class="dropdown-item" v-if="hasPermission('COMPANY_TARIFF_LIST')">
                                {{$t("config.companiesTariff")}}
                            </router-link>
                            <router-link  v-if="hasPermission('SETTINGS_APPRAISER_SALARY')" tag="a" to="/config/appraiserSalary" class="dropdown-item">
                                {{$t("config.appraiserSalary.title")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_EXPERT2')" tag="a" to="/config/expert2" class="dropdown-item">
                                {{$t("config.expert2.title")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_SYNC_DB_HISTORY')" tag="a" to="/config/sync-db-history" class="dropdown-item">
                                {{$t("config.syncDbHistory")}}
                            </router-link>
                            <router-link v-if="hasPermission('SETTINGS_EVALUATION_AMOUNT')" tag="a" to="/config/evaluation-amount" class="dropdown-item">
                                {{$t("config.evaluationAmount")}}
                            </router-link>
                            <a href="#" class="dropdown-item" @click="clearAllCaches">{{$t("main.clearAllCaches")}}</a>
                            <a href="#" class="dropdown-item" @click="logOut">{{$t("main.logOut")}}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapState} from 'vuex';
    import {DEFAULT_LANGUAGE} from '@/shared/constants/language';
    import i18n from '@/i18n';
    import {LOGIN_METHOD} from "@/shared/constants/loginMethod";

    export default {
        data() {
            return {
                userNavShow: false,
                langNavShow: false,
                languageCode: '',
                currencyRates: []
            }
        },
        computed: {
            ...mapState(['navbar', 'sidebar', 'profile', 'loginMethod']),
            language() {
                if (this.languageCode === 'ru') {
                    return 'Русский язык';
                } else {
                    return 'Ўзбек тили';
                }
            },
            isLoggedInViaKeycloak() {
                return this.loginMethod === LOGIN_METHOD.KEYCLOAK
            }
        },
        methods: {
            clearAllCaches() {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('main.clearAllCaches'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#dd3333',
                confirmButtonText: 'Ўчириш',
                cancelButtonText: 'Бекор қилиш'
              }).then((result) => {
                if (result.value) {
                  this.$http.delete('/clear-all-cache')
                      .then((res) => {
                        console.log(res);
                        this.$swal({
                          title: this.$t('messages.common.success'),
                          text: this.$t('main.clearAllCaches'),
                          type: 'success'
                        });
                      }, () => {
                        this.$swal({
                          title: this.$t('messages.common.error'),
                          text: this.$t('main.clearAllCaches'),
                          type: 'error'
                        });
                      });
                }
              });
            },
            logOut() {
                this.$store.dispatch('logOut');
            },
            sideBarToggleMini() {
                this.$store.dispatch('sideBarToggleMini');
            },
            sideBarToggleMobile() {
                this.$store.dispatch('sideBarToggleMobile');
            },
            userNavToggle() {
                this.userNavShow = !this.userNavShow;
            },
            userNavHide() {
                this.userNavShow = false;
            },
            langNavToggle() {
                this.langNavShow = !this.langNavShow;
            },
            langNavHide() {
                this.langNavShow = false;
            },
            changeLanguage(langCode) {
                this.languageCode = langCode;
                i18n.locale = langCode;
                localStorage.setItem('x_lang', langCode);
                document.querySelector('html').setAttribute('lang', langCode);
                // window.location.reload();
            },
            getCurrency() {
              this.$http.get('/currency/main')
                  .then((res) => {
                    res.data.forEach((element) => {
                      var value = '1 ' + element.ccode + '=' + element.crate;
                      this.currencyRates.push({"value": value})
                    });
                  }, () => {
                    this.$swal({
                      title: this.$t('messages.common.error'),
                      text: this.$t('messages.common.errorOccurred'),
                      type: 'error'
                    });
                  });
            }
        },
        created() {
            let lang = localStorage.getItem('x_lang');
            if (lang && lang.length > 0) {
                this.languageCode = lang;
            } else {
                this.languageCode = DEFAULT_LANGUAGE;
            }

            //currency
            this.getCurrency();
        }
    }
</script>

<style>
    .nav-dropdown-language .dropdown-menu .active {
        background-color: #cccccc;
    }
</style>